import React from 'react';
import { Link } from 'react-router-dom';
import { MAX_CONTENT_WIDTH } from '../constants/layout';

export default function WhatWeDo() {
  return (
    <>
      {/* Header/Banner */}
      <div
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 'calc(100vh - 200px)',
          padding: '48px 16px',
          backgroundColor: '#0f0f0f',
        }}
      >
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '16px',
        }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: 900,
            fontFamily: 'Helvetica, Arial, sans-serif',
            letterSpacing: '-0.05em',
            margin: 0,
            color: '#ffffff',
            lineHeight: 1.1,
            textAlign: 'center',
          }}>
            AppStack for Business
          </h1>
          <p style={{
            fontSize: '1rem',
            fontWeight: 400,
            fontFamily: 'Helvetica, Arial, sans-serif',
            margin: 0,
            color: '#cccccc',
            textAlign: 'center',
          }}>
            For growing businesses ready to reach more customers with their own website, iOS, and Android apps.
          </p>
        </div>
      </div>

      {/* Who This Is For Section */}
      <div style={{
        backgroundColor: '#151515',
        padding: '80px 32px',
        minHeight: '800px',
        display: 'flex',
        alignItems: 'center',
      }}>
        <div style={{
          maxWidth: MAX_CONTENT_WIDTH,
          margin: '0 auto',
          width: '100%',
        }}>
          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: 800,
            fontFamily: 'Helvetica, Arial, sans-serif',
            color: '#ffffff',
            margin: '0 0 48px 0',
            letterSpacing: '-0.05em',
            textAlign: 'center',
          }}>
            Who This Is For
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '32px',
          }}>
            {/* Cafes & Restaurants */}
            <div style={{
              padding: '32px',
              backgroundColor: '#232323',
              borderRadius: '16px',
              border: '1px solid #3f3f3f',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
            }}>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 700,
                fontFamily: 'Helvetica, Arial, sans-serif',
                color: '#ffffff',
                margin: 0,
                letterSpacing: '-0.03em',
              }}>
                Cafes & Restaurants
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#d4d4d4',
                margin: 0,
                lineHeight: 1.6,
                fontFamily: 'Helvetica, Arial, sans-serif',
              }}>
                Accept online orders, showcase your menu with photos, and send push notifications about daily specials and seasonal items.
              </p>
            </div>

            {/* Online Stores */}
            <div style={{
              padding: '32px',
              backgroundColor: '#232323',
              borderRadius: '16px',
              border: '1px solid #3f3f3f',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
            }}>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 700,
                fontFamily: 'Helvetica, Arial, sans-serif',
                color: '#ffffff',
                margin: 0,
                letterSpacing: '-0.03em',
              }}>
                Online Stores
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#d4d4d4',
                margin: 0,
                lineHeight: 1.6,
                fontFamily: 'Helvetica, Arial, sans-serif',
              }}>
                Sell products with full inventory tracking, iPhone, iPad, and Android apps, and your own branded storefront.
              </p>
            </div>

            {/* Small Business Owners */}
            <div style={{
              padding: '32px',
              backgroundColor: '#232323',
              borderRadius: '16px',
              border: '1px solid #3f3f3f',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
            }}>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 700,
                fontFamily: 'Helvetica, Arial, sans-serif',
                color: '#ffffff',
                margin: 0,
                letterSpacing: '-0.03em',
              }}>
                Small Business Owners
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#d4d4d4',
                margin: 0,
                lineHeight: 1.6,
                fontFamily: 'Helvetica, Arial, sans-serif',
              }}>
                Get discovered online without the complexity. Professional presence without hiring developers or designers.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* What's Included Section */}
      <div style={{
        backgroundColor: '#1a1a1a',
        padding: '80px 32px',
        minHeight: '800px',
        display: 'flex',
        alignItems: 'center',
      }}>
        <div style={{
          maxWidth: MAX_CONTENT_WIDTH,
          margin: '0 auto',
          width: '100%',
        }}>
          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: 800,
            fontFamily: 'Helvetica, Arial, sans-serif',
            color: '#ffffff',
            margin: '0 0 48px 0',
            letterSpacing: '-0.05em',
            textAlign: 'center',
          }}>
            The Complete Package
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '32px',
            gridAutoRows: '1fr',
          }}>
            {/* Feature 1 */}
            <div style={{
              padding: '32px',
              backgroundColor: '#232323',
              borderRadius: '16px',
              border: '1px solid #3f3f3f',
              display: 'flex',
              flexDirection: 'column',
            }}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '16px' }}>
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 700,
                fontFamily: 'Helvetica, Arial, sans-serif',
                color: '#ffffff',
                margin: '0 0 12px 0',
                letterSpacing: '-0.03em',
              }}>
                Push Notifications
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#d4d4d4',
                margin: 0,
                lineHeight: 1.6,
                fontFamily: 'Helvetica, Arial, sans-serif',
              }}>
                Alert customers about new products, daily specials, and promotions directly on their phone.
              </p>
            </div>

            {/* Feature 2 */}
            <div style={{
              padding: '32px',
              backgroundColor: '#232323',
              borderRadius: '16px',
              border: '1px solid #3f3f3f',
              display: 'flex',
              flexDirection: 'column',
            }}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '16px' }}>
                <polyline points="23 4 23 10 17 10"></polyline>
                <polyline points="1 20 1 14 7 14"></polyline>
                <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
              </svg>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 700,
                fontFamily: 'Helvetica, Arial, sans-serif',
                color: '#ffffff',
                margin: '0 0 12px 0',
                letterSpacing: '-0.03em',
              }}>
                Continuous Updates
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#d4d4d4',
                margin: 0,
                lineHeight: 1.6,
                fontFamily: 'Helvetica, Arial, sans-serif',
              }}>
                Your apps stay modern with new iOS and Android features and security improvements.
              </p>
            </div>

            {/* Feature 3 */}
            <div style={{
              padding: '32px',
              backgroundColor: '#232323',
              borderRadius: '16px',
              border: '1px solid #3f3f3f',
              display: 'flex',
              flexDirection: 'column',
            }}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '16px' }}>
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
              </svg>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 700,
                fontFamily: 'Helvetica, Arial, sans-serif',
                color: '#ffffff',
                margin: '0 0 12px 0',
                letterSpacing: '-0.03em',
              }}>
                Your Dashboard
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#d4d4d4',
                margin: 0,
                lineHeight: 1.6,
                fontFamily: 'Helvetica, Arial, sans-serif',
              }}>
                Simple dashboard to update your content, products, and settings. No coding needed.
              </p>
            </div>

            {/* Feature 4 */}
            <div style={{
              padding: '32px',
              backgroundColor: '#232323',
              borderRadius: '16px',
              border: '1px solid #3f3f3f',
              display: 'flex',
              flexDirection: 'column',
            }}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '16px' }}>
                <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line>
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                <line x1="12" y1="22.08" x2="12" y2="12"></line>
              </svg>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 700,
                fontFamily: 'Helvetica, Arial, sans-serif',
                color: '#ffffff',
                margin: '0 0 12px 0',
                letterSpacing: '-0.03em',
              }}>
                Product Management
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#d4d4d4',
                margin: 0,
                lineHeight: 1.6,
                fontFamily: 'Helvetica, Arial, sans-serif',
              }}>
                Add, edit, and organize your products with photos and videos.
              </p>
            </div>

            {/* Feature 5 */}
            <div style={{
              padding: '32px',
              backgroundColor: '#232323',
              borderRadius: '16px',
              border: '1px solid #3f3f3f',
              display: 'flex',
              flexDirection: 'column',
            }}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '16px' }}>
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
              </svg>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 700,
                fontFamily: 'Helvetica, Arial, sans-serif',
                color: '#ffffff',
                margin: '0 0 12px 0',
                letterSpacing: '-0.03em',
              }}>
                Online Ordering
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#d4d4d4',
                margin: 0,
                lineHeight: 1.6,
                fontFamily: 'Helvetica, Arial, sans-serif',
              }}>
                Accept orders directly through your website and apps with inventory tracking.
              </p>
            </div>

            {/* Feature 6 */}
            <div style={{
              padding: '32px',
              backgroundColor: '#232323',
              borderRadius: '16px',
              border: '1px solid #3f3f3f',
              display: 'flex',
              flexDirection: 'column',
            }}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '16px' }}>
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                <line x1="8" y1="21" x2="16" y2="21"></line>
                <line x1="12" y1="17" x2="12" y2="21"></line>
              </svg>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 700,
                fontFamily: 'Helvetica, Arial, sans-serif',
                color: '#ffffff',
                margin: '0 0 12px 0',
                letterSpacing: '-0.03em',
              }}>
                Your Own Brand
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#d4d4d4',
                margin: 0,
                lineHeight: 1.6,
                fontFamily: 'Helvetica, Arial, sans-serif',
              }}>
                Your logo, your colors, your style. Everything is designed around your unique brand identity.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* How It Works Section */}
      <div style={{
        backgroundColor: '#0f0f0f',
        padding: '80px 20px',
        minHeight: '800px',
        display: 'flex',
        alignItems: 'center',
      }}>
        <div style={{
          maxWidth: MAX_CONTENT_WIDTH,
          margin: '0 auto',
          width: '100%',
        }}>
          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: 800,
            fontFamily: 'Helvetica, Arial, sans-serif',
            color: '#ffffff',
            margin: '0 0 48px 0',
            letterSpacing: '-0.05em',
            textAlign: 'center',
          }}>
            How It Works
          </h2>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '48px',
          }}>
            {/* Step 1 */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '24px',
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: 'var(--color-accent)',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.5rem',
                fontWeight: 700,
                fontFamily: 'Helvetica, Arial, sans-serif',
                flexShrink: 0,
              }}>
                1
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
              }}>
                <h3 style={{
                  fontSize: '1.75rem',
                  fontWeight: 700,
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  color: '#ffffff',
                  margin: 0,
                  letterSpacing: '-0.03em',
                }}>
                  Everything Built For You
                </h3>
                <p style={{
                  fontSize: '1rem',
                  color: '#d4d4d4',
                  margin: 0,
                  lineHeight: 1.6,
                  fontFamily: 'Helvetica, Arial, sans-serif',
                }}>
                  Share your vision, branding, and requirements. Our team designs and develops your custom website and iOS and Android apps from scratch.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '24px',
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: 'var(--color-accent)',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.5rem',
                fontWeight: 700,
                fontFamily: 'Helvetica, Arial, sans-serif',
                flexShrink: 0,
              }}>
                2
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
              }}>
                <h3 style={{
                  fontSize: '1.75rem',
                  fontWeight: 700,
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  color: '#ffffff',
                  margin: 0,
                  letterSpacing: '-0.03em',
                }}>
                  Launch & Hosting Included
                </h3>
                <p style={{
                  fontSize: '1rem',
                  color: '#d4d4d4',
                  margin: 0,
                  lineHeight: 1.6,
                  fontFamily: 'Helvetica, Arial, sans-serif',
                }}>
                  Once approved, your website gets deployed and your apps submitted to the App Store and Google Play. All hosting and infrastructure fully managed.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '24px',
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: 'var(--color-accent)',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.5rem',
                fontWeight: 700,
                fontFamily: 'Helvetica, Arial, sans-serif',
                flexShrink: 0,
              }}>
                3
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
              }}>
                <h3 style={{
                  fontSize: '1.75rem',
                  fontWeight: 700,
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  color: '#ffffff',
                  margin: 0,
                  letterSpacing: '-0.03em',
                }}>
                  You Manage Your Content
                </h3>
                <p style={{
                  fontSize: '1rem',
                  color: '#d4d4d4',
                  margin: 0,
                  lineHeight: 1.6,
                  fontFamily: 'Helvetica, Arial, sans-serif',
                }}>
                  Use your backend console to update products, photos, content, and settings whenever you need. No coding or technical skills required.
                </p>
              </div>
            </div>

            {/* Step 4 */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '24px',
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: 'var(--color-accent)',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.5rem',
                fontWeight: 700,
                fontFamily: 'Helvetica, Arial, sans-serif',
                flexShrink: 0,
              }}>
                4
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
              }}>
                <h3 style={{
                  fontSize: '1.75rem',
                  fontWeight: 700,
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  color: '#ffffff',
                  margin: 0,
                  letterSpacing: '-0.03em',
                }}>
                  Always Running Smoothly
                </h3>
                <p style={{
                  fontSize: '1rem',
                  color: '#d4d4d4',
                  margin: 0,
                  lineHeight: 1.6,
                  fontFamily: 'Helvetica, Arial, sans-serif',
                }}>
                  All updates, maintenance, security, and technical support handled for you. If anything breaks, it gets fixed. That's what's included.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Done-For-You Section */}
      <div style={{
        backgroundColor: '#1a1a1a',
        padding: '80px 20px',
        minHeight: '800px',
        display: 'flex',
        alignItems: 'center',
      }}>
        <div style={{
          maxWidth: MAX_CONTENT_WIDTH,
          margin: '0 auto',
          width: '100%',
          textAlign: 'center',
        }}>
          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: 800,
            fontFamily: 'Helvetica, Arial, sans-serif',
            color: '#ffffff',
            margin: '0 0 24px 0',
            letterSpacing: '-0.05em',
          }}>
            Done-For-You, Not DIY
          </h2>
          <p style={{
            fontSize: '1rem',
            color: '#cccccc',
            margin: '0 0 48px 0',
            lineHeight: 1.6,
            fontFamily: 'Helvetica, Arial, sans-serif',
            maxWidth: '700px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}>
            Unlike website builders where you're on your own, everything from development to deployment to ongoing maintenance is handled for you.
          </p>
          <Link
            to="/business/pricing"
            style={{
              display: 'inline-block',
              backgroundColor: 'var(--color-accent)',
              color: 'white',
              padding: '16px 32px',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: 600,
              fontFamily: 'Helvetica, Arial, sans-serif',
              textDecoration: 'none',
              transition: 'transform 0.2s ease, opacity 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.02)';
              e.currentTarget.style.opacity = '0.9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.opacity = '1';
            }}
          >
            View Pricing Plans
          </Link>
        </div>
      </div>
    </>
  );
}
